import { useEffect, useState } from 'react'
import { useAuth } from 'react-oidc-context'
import { Navigate } from 'react-router-dom'
import { useUserStore } from '../../../store/storeUser'

export const LoginPage = () => {
    const { activeNavigator, isLoading, isAuthenticated, signinRedirect } = useAuth()
    const autoLogin = !activeNavigator && !isLoading && !isAuthenticated
    const [userLoaded, setUserLoaded] = useState(false)

    const { getUserPersonalData, userPersonalData } = useUserStore((state) => state)

    useEffect(() => {
        if (autoLogin) {
            signinRedirect()
        }
    }, [autoLogin])

    useEffect(() => {
        if (isAuthenticated) {
            getUserPersonalData().then(() => {
                setUserLoaded(true)
            })
        }
    }, [isAuthenticated])

    if (isAuthenticated && userLoaded && userPersonalData) {
        const urlParams = new URLSearchParams(window.location.search)
        const assistant_id = urlParams.get('assistant_id')
        const return_page = urlParams.get('rpg') || '/'

        if (userPersonalData.is_new) {
            ym(100275765, 'reachGoal', 'registrationAA')
        }

        ym(100275765, 'setUserID', userPersonalData.user_uuid)

        let redirectTo = return_page === '/login' ? '/' : return_page;
        let params = []
        if (assistant_id) { params.push(`assistant_id=${assistant_id}`) }
        if (params.length > 0) { redirectTo += `?${params.join('&')}` }

        return <Navigate to={redirectTo} />
    }

    return <></>
}
